<template>
  <main class="container my-2 mt-3" style="max-width: 1000px">
    <SimuladorStep v-if="!loading" :step="3" :valor="plano.valorMensal"
      :periodicidade="plano.modeloCobranca.periodicidade">
    </SimuladorStep>
    <div class="d-flex row mt-1" v-if="!loading">
      <div class="col">
        <ul class="nav nav-tabs">
          <li class="nav-item text-center" v-for="(item, index) in plano.metodoPagamento" :key="index">
            <a class="nav-link" :class="plano.modeloCobranca.modeloCobrancaId === item.modeloCobrancaId ? 'active' : ''"
              aria-current="page" href="#" @click="changeModeloCobranca(item)">
              <span class="icon-pagamento">
                <i :class="item.icon"></i>
              </span>
              <br />
              <span style="color:black;font-size:10px">{{ item.label }}</span>
            </a>
          </li>
        </ul>

        <div v-if="erro" class=" row  col-12  my-2 badge-danger text-center p-3 text-uppercase mt-3">
          {{ erro }}
        </div>
        

        <CheckoutCartao
          v-if="!loading && !erro && (!plano.modeloCobranca.formaPagamento || plano.modeloCobranca.formaPagamento == 'CARTAO_CREDITO')">
        </CheckoutCartao>

        <CheckoutPix v-if="!loading && !erro && plano.modeloCobranca.formaPagamento == 'PIX'">
        </CheckoutPix>

        <CheckoutBoleto v-if="!loading && !erro && plano.modeloCobranca.formaPagamento == 'BOLETO'">
        </CheckoutBoleto>
      </div>
    </div>
    <Loading v-if="loading" :textoMensagem="mensagemLoading"></Loading>
  </main>
</template>

<script>
import Loading from "@/components/Loading.vue";
import SimuladorStep from "@/components/assinaturas/SimuladorStep.vue";
import CheckoutCartao from "@/components/assinaturas/CheckoutCartao.vue";
import CheckoutBoleto from "@/components/assinaturas/CheckoutBoleto.vue";
import CheckoutPix from "@/components/assinaturas/CheckoutPix.vue";

import { APIService } from "../../APIService";
const apiService = new APIService();

import { SimuladorService } from "../../service/assinatura/SimuladorService";
import { handleAccessToken } from '@/shared/helpers/helpers'
const simuladorService = new SimuladorService();

export default {
  name: "SimuladorStep3",
  props: [],
  components: { Loading, SimuladorStep, CheckoutCartao, CheckoutBoleto, CheckoutPix },
  data() {
    return {
      loading: false,
      mensagemLoading: "",
      plano: {
        modeloCobranca: {}
      },
      erro: null,
      cepCobranca: "0",
      loadingCep: false,
      cepNaoLocalizado: false
    };
  },
  mounted() {
    this.mensagemLoading = ""
    const _plano = localStorage.getItem("simulacao-plano");
    if (_plano) {
      this.plano = JSON.parse(_plano);
    }

    const token = sessionStorage.getItem('token')

    if (token) {
      const accessToken = sessionStorage.getItem('accessToken')
      handleAccessToken(accessToken).then(() => (this.loading = false))
    }

    if (token) {
      this.loading = true;
      apiService
        .obterDadosUsuario(token)
        .then((response) => this.$store.dispatch('loginApp', response));
        this.loading = false;
    } else {
      this.$store.dispatch('loginApp', null)
    }
    // this.contratarPlano();
  },
  methods: {
    contratarPlano() {
      this.erro = "";
      this.loading = true;
      this.mensagemLoading = "Estamos processanto sua solicitação. Por favor, aguarde um momento."


      if (this.plano.modeloCobranca.formaPagamento == 'PIX') {
        this.mensagemLoading = "Estamos gerando o seu PIX. Por favor, aguarde um momento."
      }

      if (this.plano.modeloCobranca.formaPagamento == 'BOLETO') {
        this.mensagemLoading = "Estamos gerando o seu BOLETO. Por favor, aguarde um momento."
      }

      apiService
        .contratarPlano(this.plano)
        .then((res) => {
          this.plano = res;
          localStorage.setItem("simulacao-plano", JSON.stringify(this.plano));
          this.loading = false;
        })
        .catch((error) => {
          this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
        })
        .finally(() => (this.loading = false));
    },
    changeModeloCobranca(modeloCobranca) {
      this.recalcular();
      this.plano.modeloCobranca = modeloCobranca;
      
      // this.contratarPlano();
    },
    formatPeriodicidade(periodicidade) {
      return simuladorService.formatPeriodicidade(periodicidade);
    },
    recalcular() {
      simuladorService.calcularValorParcelas(this.plano);
    },
  },
};
</script>

<style scoped>
.texto-aviso {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 45px;

}

.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  transition: 0.5s;
  color: var(--cor-principal);
  overflow: hidden;
}

.icon-pagamento {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  transition: 0.5s;
  color: var(--cor-principal);
  overflow: hidden;
}
</style>
